import { createRoom, deleteRoom, updateRoom } from 'api/rooms.api';
import displayError from 'utils/displayError';
import { $form, $view, $detail } from 'signals/global.signals';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { fetchAndSetRoomsData } from 'components/views/FounderRooms/_helpers/founderRooms.resolvers';
import getSelectValue from 'utils/getSelectValue';
import { getOrgDocuments } from 'api/documents.api';
import displayNotification from 'utils/displayNotification';
export async function handleSubmitCreateRoom() {
  try {
    $view.update({
      isModalLoading: true,
    });
    let filesToInclude = $form.value?.filesToInclude || [];
    if (getSelectValue($form.value?.dataVaultInclusion) === 'all') {
      const allFiles = await getOrgDocuments($detail.value.organizationId);
      filesToInclude = allFiles.data.map((file) => file.id);
    }
    const createData = {
      name: $form.value.name,
      dealId: getSelectValue($form.value.dealId),
      description: $form.value.description,
      minimumInvestment: $form.value.minimumInvestment,
      usesOfCapital: $form.value.usesOfCapital,
      cap: $form.value.cap,
      isMrrIncluded: $form.value.isMrrIncluded,
      isArrIncluded: $form.value.isArrIncluded,
      isCashOnHandIncluded: $form.value.isCashOnHandIncluded,
      isLiabilitiesIncluded: $form.value.isLiabilitiesIncluded,
      isOtherAssetsIncluded: $form.value.isOtherAssetsIncluded,
      isActive: $form.value.isActive,
      isPublic: $form.value.isPublic,
      isAllFilesIncluded: $form.value.isAllFilesIncluded,
      filesToInclude: filesToInclude,
    };
    await createRoom(createData);
    handleHideModal();
    await fetchAndSetRoomsData();
  } catch (error) {
    displayError({
      message: 'Failed to create room. Please check your information and try again.',
      title: 'Room Creation Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
}

export async function handleSubmitUpdateRoom() {
  try {
    $view.update({
      isModalLoading: true,
    });
    const updateData = {
      name: $form.value.name,
      dealId: getSelectValue($form.value.dealId),
      description: $form.value.description,
      minimumInvestment: $form.value.minimumInvestment,
      usesOfCapital: $form.value.usesOfCapital,
      cap: $form.value.cap,
      isMrrIncluded: $form.value.isMrrIncluded,
      isArrIncluded: $form.value.isArrIncluded,
      isCashOnHandIncluded: $form.value.isCashOnHandIncluded,
      isLiabilitiesIncluded: $form.value.isLiabilitiesIncluded,
      isOtherAssetsIncluded: $form.value.isOtherAssetsIncluded,
      isActive: $form.value.isActive,
      isPublic: $form.value.isPublic,
      isAllFilesIncluded: $form.value.isAllFilesIncluded,
      filesToInclude: $form.value.filesToInclude,
    };
    await updateRoom($form.value.id, updateData);

    handleHideModal();
    await fetchAndSetRoomsData();

    displayNotification({
      message: 'Room updated successfully.',
      title: 'Room Update',
      type: 'success',
    })
  } catch (error) {
    displayError({
      message: 'Failed to update room. Please check your information and try again.',
      title: 'Room Update Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
}

export async function handleSubmitDeleteRoom() {
  try {
    $view.update({
      isModalLoading: true,
    });
    await deleteRoom($form.value.id);
    handleHideModal();
    await fetchAndSetRoomsData();
  } catch (error) {
    displayError({
      message: 'Failed to delete room. Please try again.',
      title: 'Room Deletion Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
}

export function handleChangeDealSelect({ name, value }) {
  const deal = $view.value.dealOptions?.find((dealOption) => dealOption.value === value);

  $form.update({
    ...$form.value,
    [name]: value,
    usesOfCapital: deal.usesOfCapital,
    minimumInvestment: deal.minimumInvestment,
    cap: deal.cap,
    typeOfRaise: deal.typeOfRaise,
    investmentStage: deal.investmentStage,
  });
}
